<!--
  This page is for the core app.
  Includes the dashboard (document input) and workspace (generate steps 1 and 2).
-->

<template>
  <AppLayout>
    <v-fade-transition hide-on-leave>
      <Dashboard v-if="!showWorkspace" />
    </v-fade-transition>
    <v-fade-transition hide-on-leave>
      <div class="appView" v-if="showWorkspace">
        <ProgressBar @diagramDownload="diagramDownload = true" />
        <Workspace
          :diagramDownload="diagramDownload"
          @diagramDownloaded="diagramDownload = false"
          ref="workspace"
        />
      </div>
    </v-fade-transition>
  </AppLayout>
</template>

<script>
import { Workspace, ProgressBar } from '@/components/generate';
import { AppLayout } from '../layouts/';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { DOC_BLANK, DOC_TITLE } from '@/data/constants/constantsMessages';
import Dashboard from '@/components/generate/Dashboard';

export default {
  name: 'AppView',
  components: {
    Dashboard,
    Workspace,
    ProgressBar,
    AppLayout,
  },
  data() {
    return {
      diagramDownload: false,
      error: false,
      info: false,
      blank: DOC_BLANK,
      title: DOC_TITLE,
    };
  },

  created() {
    window.addEventListener('beforeunload', this.closePrompt);
  },

  computed: {
    ...mapState('draft', {
      browserPrompt: (state) => state.browserPrompt,
      claims: (state) => state.claims,
      step: (state) => state.step,
      showWorkspace: (state) => state.showWorkspace,
    }),
    ...mapGetters('draft', ['validClaims', 'initialOutline']),
  },

  watch: {
    showWorkspace: {
      handler(val) {
        const { user, patchUserMetadata } = this.$auth;

        if (user && val && this.step === 1 && !user?.metaData.seenTutorialInputs) {
          this.$tours.homeTour.start();
          patchUserMetadata({ draftTutorialClaims: null, seenTutorialInputs: true });
        }
      },
    },
  },

  methods: {
    ...mapMutations('draft', ['resetState']),

    closePrompt(e) {
      e.preventDefault();
      if (this.browserPrompt && (this.validClaims || !this.initialOutline)) {
        e.returnValue = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.appView {
  display: flex;
  flex-direction: column;
  padding-top: 48px;
  height: 100vh;
  overflow-y: hidden;
  overflow-x: hidden;
}

.errorAlert {
  position: absolute;
  top: 60px;
  z-index: 10;
  width: 100%;
}
</style>
